// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2O-vu","inputWrap":"styles_inputWrap__1Frkb","input":"styles_input__2dqIZ"};